import { render } from "./CustomCheckbox.vue?vue&type=template&id=1960c6da"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__